export default __webpack_public_path__ + "static/media/1_0042.31428934.webp";